import { render, staticRenderFns } from "./edit-blog-dialog.vue?vue&type=template&id=351743b3&"
import script from "./edit-blog-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-blog-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports